<template>
  <div class="img-and-content-container"
       :class="{ 'img-right': !eleConfig.otherConfig.imgLeftFlag }"
       :style="containerStyle">
    <div class="img-box">
      <template v-if="isVideo">
        <div class="video-mask" @click="changeVideoPlay">
          <dol-icon type="PlayCircleOutlined" v-if="!videoPlayFlag"/>
        </div>
        <video width="100%" height="auto" ref="video" autoplay @play="videoPlay" @pause="videoPause" :src="imgSrc" />
      </template>
      <img v-else :src="imgSrc">
    </div>
    <div class="text-box">
      <div class="text-container">
        <h2 class="title" :style="{ color: eleConfig.otherConfig.titleColor }">
          {{ $dt(eleConfig, 'title') }}
        </h2>
        <div class="content" :style="{ color: eleConfig.otherConfig.contentColor }">
          {{ $dt(eleConfig, 'content') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import componentMixin from './componentMixin';

export default {
  mixins: [componentMixin],
  name: "imgAndContentFullWidth",
  data() {
    return {
      videoPlayFlag: true,
    };
  },
  computed: {
    containerStyle() {
      const style = {};
      if (this.eleConfig.backgroundImage) {
        const imgPath = this.$Dolphin.path.publicPath + this.eleConfig.backgroundImage.filePath;
        style.backgroundImage = `url(${imgPath})`;
      } else if (this.eleConfig.backgroundColor) {
        style.backgroundColor = this.eleConfig.backgroundColor;
      } else {
        style.backgroundColor = '#ffffff';
      }
      style.alignItems = this.eleConfig.otherConfig.centerFlag ? 'center' : 'flex-start';
      style.paddingTop = this.getNumber(this.eleConfig.paddingTop) + 'px';
      style.paddingBottom = this.getNumber(this.eleConfig.paddingBottom) + 'px';
      return style;
    },
    imgSrc() {
      const image = this.$dt(this.eleConfig, 'image') || this.eleConfig.image;
      return image ? this.$Dolphin.path.publicPath + image.filePath : '';
    },
    isVideo() {
      const fileInfo = this.$dt(this.eleConfig, 'image') || this.eleConfig.image;
      return /video/.test(fileInfo?.fileType || '')
    },
  },
  methods: {
    changeVideoPlay() {
      this.videoPlayFlag ? this.$refs.video.pause() : this.$refs.video.play();
    },
    videoPlay() {
      this.videoPlayFlag = true;
    },
    videoPause() {
      setTimeout(() => {
        this.videoPlayFlag = false;
      }, 50)
    },
  }
};
</script>

<style scoped lang="scss">
.img-and-content-container {
  width: 100%;
  //padding: 96px 0;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;

  &.img-right {
    flex-direction: row-reverse;
  }

  .img-box {
    flex: 1;
    position: relative;

    .video-mask {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 64px;
      color: white;
    }

    img {
      width: 100%;
      height: auto;
    }
  }

  .text-box {
    flex: 1;

    .text-container {
      width: 500px;
      margin: 0 auto;
    }

    .title {
      font-size: 32px;
      font-weight: 600;
      margin-bottom: 16px;
      line-height: 45px;
      color: #003C82;
    }

    .content {
      font-size: 18px;
      white-space: pre-wrap;
      line-height: 25px;
      color: #333333;
    }
  }
}
</style>
